import React from "react"
import { CacheProvider } from "@emotion/core"
import createCache from "@emotion/cache"
import { config } from "@fortawesome/fontawesome-svg-core"
import { CSP_STYLE_NONCE } from "./src/services/cspNonce"

import { AppProvider } from "./src/context/AppContext"
import "./static/styles/global.scss"
import { RefillsProvider } from "./src/components/MedEnsure/Refills/services/RefillsContext"

// CSS is bundled via global.scss; prevent a second runtime <style> injection.
config.autoAddCss = false

const emotionCache = createCache({
  key: "css",
  nonce: CSP_STYLE_NONCE,
})

export const wrapRootElement = ({ element }) => (
  <CacheProvider value={emotionCache}>
    <AppProvider>
      <RefillsProvider>{element}</RefillsProvider>
    </AppProvider>
  </CacheProvider>
)
